import React from 'react';
import { connect } from 'react-redux';
import { Routes } from '@common-packages/routes-definitions';

import AuthorizedCustomRoute from '../shared/authorization/authorizedCustomRoute';
import GlobalContextPage from '../shared/displayComponents/globalContextPage.component';
import { isFetchingContextSelector } from '../entity/store/selectors';

import BinderMaintenance from './binderMaintenance.container';

const BinderMaintenancePage = connect(state => ({
  isFetchingContext: isFetchingContextSelector(state),
}))(GlobalContextPage);

const BinderMaintenanceRoute = () => (
  <AuthorizedCustomRoute
    exact
    path={Routes.binderMaintenance.MAIN}
    wrapper={BinderMaintenancePage}
    component={BinderMaintenance}
    disableBreadcrumbs
    hideGlobalContext
  />
);

export default BinderMaintenanceRoute;
